const validateEmptyString = (value) => {
    if (!value){return false}
    if (value.length > 0){
        return true
    } else {
        return false
    }
}

export default validateEmptyString